import { toPairs } from 'lodash-es'

export default function debugFields(obj, dbg) {
  for (const [dbgKey, dbgVal] of toPairs(dbg)) {
    obj[dbgKey] = dbgVal
  }

  return obj
}
